// Periodo de datos que se pide al generar un reporte, en días de calendario de CDMX.
import { mxDayEndUtc, mxDayStartUtc, mxLastDaysWindow, mxTodayWindow } from '@/lib/dateHelpers';

export type ReportPeriodPreset = 'today' | '7d' | '30d' | 'range';

export interface ReportPeriodSelection {
    preset: ReportPeriodPreset;
    /** `YYYY-MM-DD`; solo cuenta con `range`. */
    fromDay?: string;
    toDay?: string;
}

export const REPORT_PERIOD_OPTIONS: { value: ReportPeriodPreset; label: string }[] = [
    { value: 'today', label: 'Hoy' },
    { value: '7d', label: 'Últimos 7 días' },
    { value: '30d', label: 'Últimos 30 días' },
    { value: 'range', label: 'Rango' },
];

/** Ventana ISO del periodo; `null` si el rango está incompleto o invertido. */
export function reportPeriodWindow(
    selection: ReportPeriodSelection,
    now: Date = new Date(),
): { from: string; to: string } | null {
    switch (selection.preset) {
        case 'today':
            return mxTodayWindow(now);
        case '7d':
            return mxLastDaysWindow(7, now);
        case '30d':
            return mxLastDaysWindow(30, now);
        case 'range': {
            const { fromDay, toDay } = selection;
            if (!fromDay || !toDay || fromDay > toDay) return null;
            return { from: mxDayStartUtc(fromDay), to: mxDayEndUtc(toDay) };
        }
    }
}
